import { createContext, useContext, useState, useEffect } from "react";

// export const AuthNewProvider = ({ children }) => {
//   // const [user, setUser] = useState(null);

//   const [user, setUser] = useState(() => {
//     const stored = localStorage.getItem("authUser");
//     return stored ? JSON.parse(stored) : null;
//   });

//   /* 🔥 SYNC WITH LOCALSTORAGE */
//   useEffect(() => {
//     if (user) {
//       localStorage.setItem("authUser", JSON.stringify(user));
//     } else {
//       localStorage.removeItem("authUser");
//     }
//   }, [user]);
//   const login = (userData) => {
//     setUser(userData);
//   };

//   const logout = () => {
//     setUser(null);
//     localStorage.removeItem("authUser");
//   };

//   return (
//     <AuthNewContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthNewContext.Provider>
//   );
// };

import axios from "axios";
const AuthNewContext = createContext(null);
export const AuthNewProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("authUser");
    return stored ? JSON.parse(stored) : null;
  });

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  /* 🔥 SYNC WITH LOCALSTORAGE */
  useEffect(() => {
    if (user) {
      localStorage.setItem("authUser", JSON.stringify(user));
    } else {
      localStorage.removeItem("authUser");
    }
  }, [user]);
  useEffect(() => {
    if (!user?.token) return;

    const parseJwt = (token) => {
      try {
        const base64 = token
          .split(".")[1]
          .replace(/-/g, "+")
          .replace(/_/g, "/");
        return JSON.parse(atob(base64));
      } catch {
        return null;
      }
    };

    const interval = setInterval(() => {
      const decoded = parseJwt(user.token);

      if (!decoded?.exp) {
        logout();
        return;
      }

      const expiryTime = decoded.exp * 1000;

      if (Date.now() >= expiryTime) {
        console.log("🔥 Token expired → auto logout");
        logout();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [user]);

  /* ================= LOGIN ================= */
  const login = (userData) => {
    setUser(userData);
    console.log("Userdata", userData);

    console.log("UserData loginId", userData?.loginId);

    // 🔥 store loginHistoryId
    if (userData.loginId) {
      localStorage.setItem("loginId", userData.loginId);
    }

    console.log("lcoaltorag if", localStorage.getItem("loginId"));
  };

  /* ================= LOGOUT ================= */
  // const logout = async () => {
  //   try {
  //     const loginHistoryId = localStorage.getItem("loginHistoryId");

  //     console.log("Logout ID:", loginHistoryId);

  //     if (loginHistoryId) {
  //       await axios.post(`${BASE_URL}/api/logout`, {
  //         loginHistoryId,
  //       });
  //     }
  //   } catch (err) {
  //     console.error("Logout API error:", err);
  //   } finally {

  //     setUser(null);
  //     localStorage.removeItem("authUser");
  //     localStorage.removeItem("loginHistoryId");
  //   }
  // };
  const logout = async () => {
    try {
      const loginHistoryId = localStorage.getItem("loginId");

      console.log("Logout ID:", loginHistoryId);

      if (!loginHistoryId) {
        console.warn("No loginHistoryId found ❌");
        return;
      }

      const res = await axios.post(`${BASE_URL}/api/auth/logout`, {
        loginHistoryId: Number(loginHistoryId), // 🔥 FORCE NUMBER
      });

      console.log("Logout response:", res.data);
    } catch (err) {
      console.error("Logout API error FULL:", err.response || err);
    } finally {
      setUser(null);
      localStorage.removeItem("authUser");
      localStorage.removeItem("loginId");
    }
  };

  return (
    <AuthNewContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthNewContext.Provider>
  );
};
export const useAuth = () => useContext(AuthNewContext);
